import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import { AnalyticsBridge } from "@/analytics/AnalyticsBridge";
import { PublicEnhancements } from "@/PublicEnhancements";

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 60_000, refetchOnWindowFocus: false } } });
const provider = (children) => <React.StrictMode><QueryClientProvider client={queryClient}><BrowserRouter>{children}</BrowserRouter></QueryClientProvider></React.StrictMode>;
const interactiveRoot = document.getElementById("interactive-root");
const appRoot = document.getElementById("root");
if (interactiveRoot && document.getElementById("ssr-content")) {
  ReactDOM.createRoot(interactiveRoot).render(provider(<><AnalyticsBridge/><PublicEnhancements/></>));
} else if (appRoot) {
  ReactDOM.createRoot(appRoot).render(<React.StrictMode><QueryClientProvider client={queryClient}><App/></QueryClientProvider></React.StrictMode>);
}
